import { useGetTermsConditionsQuery } from 'src/store/Reducer/adminSetting';
import AboutHero from '../about/about-hero';
import AboutWhat from '../about/about-what2';

const TermsAndConditionsView = () => {

    const { data,isLoading } = useGetTermsConditionsQuery({ language: 'en' });

    return (
        <div>
            <AboutHero data={{ title: "Our", list: ["Support"] }} />
            <AboutWhat isLoading={isLoading} data={{ title: "", content: data?.text, image: '/assets/terms.jpg' }} />
        </div>
    )
}

export default TermsAndConditionsView

